import { Button, Field, Input, makeStyles } from "@fluentui/react-components";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { handleInputCheck } from "../../common/invalidCharCheck";
import { addStation } from "../../reducers/diningReducer";
import { useAppDispatch } from "../../store/store";

/* ------------------ TYPES ------------------ */

type AddStationInputs = {
  newStationName: string;
};

/* ------------------ STYLES ------------------ */

const useStyles = makeStyles({
  row: {
    display: "flex",
    alignItems: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "auto",
  },
  grow: {
    width: "100%",
    flexGrow: 1,
  },
  stationInput: {
    width: "100%",
    minWidth: "0px",
  },
});

/* ------------------ COMPONENT ------------------ */

export const AddStation: React.FC = () => {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const { handleSubmit, control, reset } = useForm<AddStationInputs>();
  // const inputValue = watch("newStationName");
  const [invalidCharError, setInvalidCharError] = useState("");

  const onSubmit = (data: AddStationInputs) => {
    dispatch(addStation(data.newStationName));
    reset({ newStationName: "" });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.row}>
        {/* Input */}
        <div className={classes.grow}>
          <Controller
            name="newStationName"
            control={control}
            defaultValue=""
            rules={{
              required: { value: true, message: "This item needs a name." },
              minLength: { value: 2, message: "Can you be more descriptive?" },
              maxLength: { value: 50, message: "Too many characters." },
            }}
            render={({ field, fieldState }) => (
              <>
                <Field
                  label="Add a station"
                  style={{ fontWeight: "400" }}
                  validationMessage={fieldState.error?.message}
                >
                  <Input
                    {...field}
                    id="newStationName"
                    placeholder="New station name"
                    className={classes.stationInput}
                    onChange={(e) => {
                      field.onChange(e);
                      setInvalidCharError(handleInputCheck(e.target.value));
                    }}
                    aria-invalid={!!fieldState.error}
                  />
                </Field>
              </>
            )}
          />

          {invalidCharError && <p>{invalidCharError}</p>}
        </div>

        {/* Button */}
        <Button appearance="primary" type="submit">
          Add
        </Button>
      </div>
    </form>
  );
};
